<template>
	<div>
		<vxe-modal v-model="modal_model" :title="modal_title" :width="modal_width" :height="modal_height" @show="modal_onshow" show-footer @hide="modal_onhide"
			destroy-on-close transfer>
			<template #default>
				<div ref="logistictrace_custom_form"></div>
				<vxe-grid ref="list" v-show="false" v-if="list_gridOptions" v-bind="list_gridOptions"
					@toolbar-button-click="list_toolbarButtonClickEvent"></vxe-grid>
			</template>
			<template #footer>
				<vxe-button status="" content="返回" @click="modal_cancel"></vxe-button>
				<vxe-button status="primary" content="确认" @click="submit"></vxe-button>
			</template>
		</vxe-modal>
	</div>
</template>
<style scoped>

</style>
<script>
	const formjson = {
		title: '表单',
		rule: {
			"width": "800",
			"height": "600",
			"fApi": [],
			"rule": [
				{
					"type": "el-divider",
					"children": [
						"报价单配置"
					]
				},
				{
					"type": "$emun",
					"field": "store",
					"title": "适用店铺",
					"value": [],
					"hidden": false,
					"props": {
						"name":"store",
						"multiple":true,
						"collapseTags":false,
						"readonly":false
					},
					"validate": [{
						"required": false,
						"message": "必填项"
					}]
				},
				{
					"type": "$switchs",
					"field": "offerenable",
					"title": "报价启用",
					"value": null,
					"hidden": false,
					"props": {
						"activeValue":5,
						"inactiveValue":6,
					},
					"validate": [{
						"required": false,
						"message": "必填项"
					}]
				}
			],
			"option": {
				"form": {
					"labelWidth": "80px",
					"hideRequiredAsterisk": false,
					"showMessage": false,
					"inlineMessage": false
				},
				"global": {
					"*": {
						"props": {
							"el": true,
							"size": "small",
							"disabled": false
						},
						"col": {
							"span": 24,
							"offset": 0
						}
					},
					"el-divider": {
						"wrap": {
							"show": false
						},
						"native": false,
						"col": {
							"span": 24,
							"offset": 0
						},
						"props": {
							"contentPosition": "left"
						}
					}
				},
				"submitBtn": false,
				"resetBtn": false
			}
		}
	}
	import modalMixins from '@_system/components/base/mixins/modal/modal.js'
	import listMixins from '@_system/components/base/mixins/list/list.js'
	export default {
		mixins: [listMixins, modalMixins],
		props: {
			row: {
				default: () => {
					return {}
				}
			},
		},
		data() {
			return {
				modal_title: '配置',
				modal_width:600,
				modal_height:500,
				// list_footerField:[
				// 	{field:'needamount',toFixed:2}
				// ]
			}
		},
		watch: {

		},
		computed: {
			device() {
				return window.systemMethods.device()
			}
		},
		created() {

		},
		mounted() {
			
		},
		methods: {
			list_beforeCreateGrid(gridOptions) {
				gridOptions.height = 550
				gridOptions.toolbarConfig = {
					size: 'mini',
					perfect: false,
					buttons: [{
						name: '新增',
						status: 'primary',
						code: 'add'
					}],
					customConfig: {
						storage: true
					},
					custom: true,
					refresh: true,
					zoom: true,
					tools: []
				}
				gridOptions.columns = [{
						type: 'checkbox',
						title: '#',
						width: 50,
					}, {
						field: 'a',
						title: 'a',
						editRender: {
							name: '$select',
							props: {
								selectoptions:[{
									value:'123',
									label:'123'
								}]
							},
							events: {
								
							}
						},
					}, {
						field: 'b',
						title: 'b',
			
					}, {
						field: 'c',
						title: 'c',
						editRender: {
							name: '$input',
							props: {
								quote: false
							},
							events: {

							}
						},
					},
					{
						title: '操作',
						fixed: "right",
						align: 'center',
						width: 65,
						slots: {
							default: ({row}) => {
								return [<el-button style="color:#F56C6C;" type = "text" size = "mini" onClick = {() => {this.delete(row)}}>删除</el-button>]
							}
						}
					}
				]
				gridOptions.formConfig = false
				gridOptions.editRules = {
					c: [{
						required: true
					},
					// {
					// 	validator({cellValue,row}){
					// 		console.log(cellValue,row)
					// 		return new Promise((resolve,reject)=>{
					// 			if( true ){
					// 				reject(new Error('自定义错误'))
					// 			}else{
					// 				resolve()
					// 			}
								
					// 		})
					// 	}
					// },
					]
				}
			},
			list() {
				return new Promise((resolve) => {
					resolve({
						list: []
					})
				})
			},
			modal_init(){
				let sourceData = JSON.parse(JSON.stringify(this.row))
				sourceData.store = sourceData.store?sourceData.store.map((item)=>{
					return parseInt(item)
				}):[],
				this.sourceData = sourceData
				let formData = JSON.parse(JSON.stringify(formjson))
				let rule = formData.rule.rule
				let option = formData.rule.option
				option.el = this.$refs.logistictrace_custom_form
				this.fApi = this.$formCreate(rule, option)
				this.fApi.nextTick(() => {
					this.regestevent(rule)
					this.setFormData()		
				})
				this.$emit('show')
			},	
			regestevent(rule){
				rule.forEach((item) => {
					if (item.field) {
						let on = {}
						if (typeof this[item.field + 'Input'] === 'function') {
							on.input = this[item.field + 'Input']
						}
						if (typeof this[item.field + 'Change'] === 'function') {
							on.input = this[item.field + 'Change']
						}
						if (typeof this[item.field + 'Button'] === 'function') {
							on.inputButtonclick = this[item.field + 'Button']
						}				
						this.fApi.updateRule(item.field, {
							on: on
						})
					}				
				})
			},
			setFormData(){
				if(this.sourceData){
					let fields = this.fApi.fields()
					fields.forEach((item) => {
						this.fApi.setValue(item, this.sourceData[item])
					})
				}
			},
			getgrid(){
				return this.$refs.list
			},
			add(){
				this.getgrid().insert({})
			},
			delete(row){
				this.getgrid().remove(row)
			},
			submit() {
				this.fApi.submit((formData) => {
					let submitData = JSON.parse(JSON.stringify(formData))
					this.submitDataFormater(submitData)
					submitData.unitUid = this.row.unitUid
					this.$api.parcel.updateconfig(submitData).then(() => {
						this.$emit('success')
						this.modal_cancel()
					})

					//console.log(submitData)
					// this.getgrid().validate(true, (res) => {
					// 	if (!res) {
					// 		let submitData = JSON.parse(JSON.stringify(formData))
					// 		this.submitDataFormater(submitData)
					// 		let detail = this.getgrid().getTableData().fullData
					// 		let data = {}
					// 		data.main = submitData
					// 		data.costorder_detail = detail
					// 		this.createJson(data)
					// 		//console.log(data,123123)
					// 		this.$emit('success', {
					// 			data: JSON.stringify(data)
					// 		})
					// 		this.modal_cancel()
					// 		console.log(data)
					// 	} else {
							// for (let i in res) {
							// 	console.log(res[i][0].rule)
							// 	let content = res[i][0].rule.$options.content
							// 	let message = res[i][0].rule.$options.message
							// 	if(content){
							// 		this.$message.error(content)
							// 	}else if(message){
							// 		this.$message.error(message)
							// 	}else{
							// 		this.$message.error('缺少必填项：' + res[i][0].column.title)
							// 	}
								
							// }
					// 	}
					// })
				})
				//this.init()
			},
			submitDataFormater(formData) {
				for (let i in formData) {
					if (i.match(/^\$son/)) {
						for (let j in formData[i]) {
							formData[i][j].forEach((item) => {
								for (let k in item) {
									if (k.match(/.*time$/g)) {
										item[k] = item[k]/1000
									}
								}
							})
						}
					} else if (i.match(/.*time$/g)) {
						console.log(i)
						formData[i] = formData[i]/1000
					}
				}
			},
			reset() {
				//this.init()
			}
		},
		components: {
			
		}
	}
</script>